import { FC, ReactNode } from "react";
import { Stack } from "@chakra-ui/react";

interface Props {
  spacing?: number;
  overflow?: string;
  children: ReactNode;
}

export const PageContentLayout: FC<Props> = (props) => {
  const {
    spacing = 2,
    overflow = "visible",
    children,
  } = props;

  return (
    <Stack
      w="calc(100% + 32px)"
      transform="translateX(-16px)"
      p="20px"
      flex="1"
      borderRadius="30px 30px 0 0"
      bg="gray.60"
      spacing={spacing}
      overflow={overflow}
    >
      {children}
    </Stack>
  );
};
